module.exports = __webpack_public_path__ + "static/img/home_biji.42c6b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_biji.png
// module id = 7khZ
// module chunks = 1